import { useState, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import "../../styles/powerball-workspace.css";
import { Sidebar } from "./Sidebar.tsx";
import { Topbar } from "./Topbar.tsx";
import { Icon } from "../icons/Icon.tsx";
import { UpgradeModal } from "../UpgradeModal.tsx";

interface AppShellProps {
  children: ReactNode;
  modePill?: { label: string; live?: boolean };
  actions?: JSX.Element;
}

export function AppShell({ children, modePill, actions }: AppShellProps): JSX.Element {
  const pathname = useLocation().pathname;
  const singles = pathname === "/singles" || pathname.startsWith("/singles/");
  const owl = pathname === "/owl" || pathname.startsWith("/owl/");
  const powerball = pathname.startsWith("/powerball") || pathname.startsWith("/form-elite")
    || singles || owl;
  const [mobileNav, setMobileNav] = useState(false);

  return (
    <div className={`app${powerball ? " pb-workspace-shell" : ""}${singles ? " singles-workspace-shell" : ""}${owl ? " owl-workspace-shell" : ""}`}>
      <Sidebar />

      {mobileNav && (
        <div className="mobile-nav-scrim" onClick={() => setMobileNav(false)}>
          <div className="mobile-sidebar" onClick={(e) => e.stopPropagation()}>
            <Sidebar />
          </div>
        </div>
      )}

      <div className="main">
        <Topbar
          modePill={modePill}
          actions={actions}
          leftSlot={
            <button
              type="button"
              className="mobile-menu-btn"
              aria-label={mobileNav ? "Close navigation" : "Open navigation"}
              aria-expanded={mobileNav}
              onClick={() => setMobileNav((v) => !v)}
            >
              <Icon name="singles" size={18} />
            </button>
          }
        />
        <div className="page">{children}</div>
      </div>

      {/* Phase G — global upgrade modal. No-op for anon visitors. */}
      <UpgradeModal />
    </div>
  );
}
